module.exports = __webpack_public_path__ + "img/flags@2x.e1c092e1.png";